export default "__VITE_ASSET__C9vio2zO__"